import React from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import type { PendingEventReschedule } from '../calendar-event-types';
import { formatDate, formatDateTime } from '../../../../../utilities';

interface ConfirmRescheduleDialogProps {
  pendingReschedule: PendingEventReschedule;
  error: string | null;
  isSubmitting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function ConfirmRescheduleDialog(props: ConfirmRescheduleDialogProps) {
  const { pendingReschedule, error, isSubmitting, onCancel, onConfirm } = props;

  return (
    <Dialog open onClose={onCancel} fullWidth maxWidth="xs">
      <DialogTitle>Bekræft ændring</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error">{error}</Alert>}
        <p>
          Vil du{' '}
          {pendingReschedule.actionType === 'move' ? 'flytte' : 'ændre tidspunktet for'}{' '}
          begivenheden <strong>{pendingReschedule.title}</strong>?
        </p>
        <p>
          Fra:{' '}
          {pendingReschedule.originalAllDay
            ? `Heldag (${formatDate(pendingReschedule.originalStartAt)})`
            : `${formatDateTime(pendingReschedule.originalStartAt)} - ${formatDateTime(
                pendingReschedule.originalEndAt
              )}`}
        </p>
        <p>
          Til:{' '}
          {pendingReschedule.allDay
            ? `Heldag (${formatDate(pendingReschedule.newStartAt)})`
            : `${formatDateTime(pendingReschedule.newStartAt)} - ${formatDateTime(
                pendingReschedule.newEndAt
              )}`}
        </p>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onCancel} disabled={isSubmitting}>
          Annuller
        </Button>
        <Button variant="contained" onClick={onConfirm} disabled={isSubmitting}>
          Gem ændring
        </Button>
      </DialogActions>
    </Dialog>
  );
}
